import { Component, OnInit } from '@angular/core';
import { GamificationService } from '../../services/gamification.service';
import { NotificationService } from '../../services/notification.service';
import { catchError, EMPTY, take, tap } from 'rxjs';
import { RecordOfAchievement } from '../models/record-of-achievement.model';
import { MedalGroup } from '../models/medal-group.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificateComponent } from '../certificate/certificate.component';
import { StreakAward } from '../models/streak-award.model';
import { Badge } from '../models/badge.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-trophy-cabinet',
  templateUrl: './trophy-cabinet.component.html',
  styleUrl: './trophy-cabinet.component.scss'
})
export class TrophyCabinetComponent implements OnInit {

  loading: boolean;
  achievements: RecordOfAchievement;
  initialItemId: string;

  constructor(private gamificationService: GamificationService, private notifications: NotificationService, private modalService: NgbModal, private route: ActivatedRoute) { }
  
  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.route.queryParamMap
      .pipe(
        tap((params) => {
          this.initialItemId = params.get('nId');
        }),
        take(1)
      )
      .subscribe();
    this.gamificationService.getAchievements$().pipe(
      tap(result => {
        this.achievements = result;
        this.loading = false;
        this.showInitialCertificate();
      }),
      catchError(err => {
        this.notifications.dangerToast(`Failed to retrieve trophy cabinet`, err);
        this.loading = false;
        return EMPTY;
      }),
      take(1)
    ).subscribe();
  }

  getMedalName(medal: MedalGroup) {
    if (medal.awardedCount > 1) {
      return `${medal.medalName} (${medal.awardedCount})`;
    } else {
      return medal.medalName;
    }
  }

  showInitialCertificate() {
    if (this.initialItemId) {
      const parts = this.initialItemId.split('.');
      const type = parts[0].toLowerCase();
      const id = parts[1];
      if (type === 'badge') {
        const badge = this.achievements.badges.find(x => x.id === id);
        if (badge) {
          this.showCertificate(badge, null, null);
        }
      } else if (type === "streak") {
        const streak = this.achievements.streakAwards.find(x => x.id === id);
        if (streak) {
          this.showCertificate(null, streak, null);
        }
      } else if (type === "medal") {
        let medalGroup;
        this.achievements.medals.forEach(group => {
          const medal = group.medals.find(x => x.id === id);
          if (medal) {
            medalGroup = group;
          }
        });
        if (medalGroup) {
          this.showCertificate(null, null, medalGroup);
        }
      }
    }
  }

  showCertificate(badge: Badge, streak: StreakAward, medal: MedalGroup) {
    const modalRef = this.modalService.open(CertificateComponent, {
      keyboard: false,
      backdrop: 'static',
      centered: true,
      size: 'md',
      modalDialogClass: 'white-modal'
    });
    modalRef.componentInstance.badge = badge;
    modalRef.componentInstance.streak = streak;
    modalRef.componentInstance.medal = medal;
    modalRef.result.then(
      () => { },
      () => { }
    );
  }
}
